

import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const HomePage = () => {

    
    const sections = [
        { title: "Step 0: Select datasets to followup on", content: 'This is the content of section 1.', path: "/workspaceTable" },

        { 
            title: 'Step 1: CRM - Invoice Collection', 
            content: 'This is the content of section 6.', 
            link: "https://www.zoho.com/en-in/crm/",
            credentials: { 
                username: 'invoices@kgrp.in', 
                password: '@)Eo9ndrnwrfkiBKAIJFop@(E!*H!12wkej' 
            }
        },
        { title: 'Step 2: Filter Table - Bucketizing Priorities', content: 'This is the content of section 1.', path: "/outputTable" },
        { title: 'Step 3: Manual matching & Validation', content: 'This is the content of section 2.', path: "/test" },
        { title: 'Step 4: Report Table', content: 'This is the content of section 4.', path: "/reportTable" },
        { title: 'HotelsGST.com', content: 'This is the content of section 3.', link:"https://hotelsgst.com/"},   
        { title: 'Hotel GSTIN Mapping', content: 'This is the content of section 5.', path: "/hotelMapping" },
        

    ];

    return (
        <div>
            <h2>Hotels GST Operation Flow</h2>
        <div style={styles.container}>
            {sections.map((section, index) => (
                <div key={index} style={styles.section}>
                    {/* Check if the section has a `path` or a `link` */}
                    {section.path ? (
                        <Link to={section.path} style={styles.link}>
                            <h2 style={styles.title}>{section.title}</h2>
                        </Link>
                    ) : section.link ? (
                        <a href={section.link} target="_blank" rel="noopener noreferrer" style={styles.link}>
                            <h2 style={styles.title}>{section.title}</h2>
                        </a>
                    ) : (
                        <h2 style={styles.title}>{section.title}</h2>
                    )}

                    {/* Render credentials in the CRM section */}
                    {section.credentials && (
                        <div style={styles.credentials}>
                            <p><strong>Credentials</strong></p>
                            <p><strong>Username:</strong> {section.credentials.username}</p>
                            <p><strong>Password:</strong> {section.credentials.password}</p>
                        </div>
                    )}
                </div>
            ))}
        </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexWrap: 'wrap', // Allow sections to wrap into new rows
        padding: '20px',
        backgroundColor: '#f5f5f5',
        justifyContent: 'space-between', // Distribute sections across the container
        alignItems: 'stretch', // Ensure sections stretch to fill the available height
        minHeight: '96vh', // Container should fill the viewport height
        boxSizing: 'border-box', // Include padding and borders in total width/height
    },
    section: {
        flex: '1 1 calc(33.33% - 16px)', // Default: 3 items per row (33.33% width each)
        minWidth: '280px', // Minimum width for sections
        height: '20.33vh', // Ensure each section takes 33.33% of the screen height
        padding: '8px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column', // Stack content vertically inside each section
        justifyContent: 'center', // Vertically center content within each section
        transition: 'all 0.3s ease',
    },
    title: {
        fontSize: '1.5rem',
        marginBottom: '10px',
        textAlign: 'center', // Center the title text
    },
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
};

// Media queries for responsive design
const mediaQueries = {
    '@media(max-width: 768px)': {
        section: {
            flex: '1 1 calc(50% - 16px)', // 2 items per row for medium screens (tablets)
        },
    },
    '@media(max-width: 480px)': {
        section: {
            flex: '1 1 100%', // 1 item per row for small screens (mobile devices)
        },
    },
};

export default HomePage;






